





















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import echarts from "echarts";
import XLSX from "@/lib/Common/excel";
import SearchTree from "@/lib/Common/searchtree";

class PageUserRequest extends PageRequest {
  keyword: string;
  areaId: number;
  startTime: string;
  endTime: string;
  totaltype: number;
  operaType: number;
}

@Component({
  components: {},
})
export default class RingRatioUseTotal extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  itemId: string = "0";
  height: number = 300;
  usebar: any; //图表
  useCount: number = 0;
  loadsear: boolean = false;
  splitnum: number = 0.15;
  get list() {
    return this.$store.state.readrecord.list;
  }
  get loading() {
    return this.$store.state.readrecord.loading;
  }
  pageChange(page: number) {
    this.$store.commit("readrecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("readrecord/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    //console.log(item)
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("readrecord/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("readrecord/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //console.log(this.pagerequest.skipCount);
    this.usebar.resize();
    this.loadsear = true;
    await this.$store
      .dispatch({
        type: "readrecord/getRingRatioUseTotal",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        this.usebar.setOption(this.$data.baroption(val.barData));
        this.$store.state.readrecord.totalCount = val.rowCount;
        this.$store.state.readrecord.list = val.tableData;
        this.useCount = val.useTotalCount;
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  get pageSize() {
    return this.$store.state.readrecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.readrecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.readrecord.currentPage;
  }
  //时间改变
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = Moment(val[0], "YYYY-MM-DD HH:mm:ss")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域树形
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("MeterType"),
      key: "meterType",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.meterType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("ReadTime"),
      key: "readTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.readTime == null
            ? ""
            : new Date(params.row.readTime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },

    {
      title: this.L("FirstReadNum"),
      key: "lastRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("LastReadNum"),
      key: "thisRead",
      sortable: true,
      width: 150,
    },
    {
      title: this.L("ThisUse"),
      key: "thisUse",
      sortable: true,
      width: 150,
    },
    {
      title: this.L("Time"),
      key: "readTimeStr",
      sortable: true,
      width: 150,
    },
  ];
  async created() {
    this.pagerequest.totaltype = 2;
    this.pagerequest.startTime = Moment()
      .add(-6, "days")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getAreaTree();
    //this.getpage();
  }
  mounted() {
    this.pagerequest.totaltype = 1;
    if (window.innerHeight > 800) {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "300px";
      this.height = window.innerHeight - 610;
    } else {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "150px";
      this.height = window.innerHeight - 460;
    }
    this.usebar = echarts.init(
      document.getElementById("echarts") as HTMLDivElement
    );
    //自动缩放
    window.addEventListener("resize", () => {
      this.usebar.resize();
    });
  }
  //汇总当前页数据
  handleSummary({ columns, data }) {
    const sums = {};
    columns.forEach((column, index) => {
      const key = column.key;
      if (index == 0) {
        sums[key] = {
          key,
          value: "合计",
        };
        return;
      }
      if (index == 2) {
        sums[key] = {
          key,
          value: this.L("ThisUse"),
        };
        return;
      }
      if (index == 3) {
        sums[key] = {
          key,
          value: this.useCount,
        };
        return;
      }
      if (index < 7 || index == 10) {
        sums[key] = {
          key,
          value: "",
        };
        return;
      }
      const values = data.map((item) => Number(item[key]));
      if (!values.every((value) => isNaN(value))) {
        const v = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[key] = {
          key,
          value: v.toFixed(2),
        };
      } else {
        sums[key] = {
          key,
          value: "",
        };
      }
    });
    return sums;
  }
  //导出数据
  async exportdata() {
    this.loadsear = true;
    this.pagerequest.operaType = 1;
    await this.$store
      .dispatch({
        type: "readrecord/getRingRatioUseTotal",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        val.tableData.forEach((ele) => {
          let info = ite.filter((p) => {
            return p.id == ele.meterType;
          });
          if (info.length > 0) {
            ele.meterType = info[0].name;
          }
          ele.readTime = new Date(ele.readTime).toLocaleString("zh", {
            hour12: false,
          });
        });
        this.exportList(val.tableData);
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  //XLXS导出数据
  exportList(list) {
    let title = [
      "区域",
      "安装位置",
      "表计类型",
      "表号",
      "户号",
      "读表时间",
      "期末数",
      "期初数",
      "用量",
      "时间",
    ];
    let keylist = [
      "areaName",
      "location",
      "meterType",
      "meterNo",
      "roomNo",
      "readTime",
      "thisRead",
      "lastRead",
      "thisUse",
      "readTimeStr",
    ];
    let filename = Moment().format("YYYYMMDDHHmmss");
    const param = {
      title: title,
      key: keylist,
      data: list,
      autoWidth: true,
      filename: filename,
    };
    XLSX.export_array_to_excel(param);
  }
  data() {
    return {
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
      //柱形图参数
      baroption(bardto) {
        return {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: bardto.legend,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: bardto.xAxis,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: bardto.series,
        };
      },
    };
  }
}
